 import navigation from './core/navigation';
 import observe from './core/observer';
 import stickyHeader from './site/stickyHeader';
 import footerMenu from './site/footerMenu';
 import productHero from './site/productHero';
 import contentTable from './site/contentTable';
 import fancybox from './site/fancybox';
 import slickSlider from './site/slickSlider';
 import productCategorytabs from './site/productCategoriesTabs';
 import fixedNav from './site/fixedNav';

$ ( function() {
  navigation.init();
  observe();
  stickyHeader.init();
  footerMenu.init();
  contentTable.init();
  productHero.init();
  fancybox.init();
  slickSlider.init();
  productCategorytabs.init();
  fixedNav.init();
});
